import moment from 'moment'
 
export default {
        //日期相差天数
   
        daysBetween(DateOne,DateTwo)  
            {   
                let OneMonth = DateOne.substring(5,DateOne.lastIndexOf ('-'));  
                let OneDay = DateOne.substring(DateOne.length,DateOne.lastIndexOf ('-')+1);  
                let OneYear = DateOne.substring(0,DateOne.indexOf ('-'));  
            
                let TwoMonth = DateTwo.substring(5,DateTwo.lastIndexOf ('-'));  
                let TwoDay = DateTwo.substring(DateTwo.length,DateTwo.lastIndexOf ('-')+1);  
                let TwoYear = DateTwo.substring(0,DateTwo.indexOf ('-'));  
            
                let cha=((Date.parse(OneMonth+'/'+OneDay+'/'+OneYear)- Date.parse(TwoMonth+'/'+TwoDay+'/'+TwoYear))/86400000);   
                return Math.abs(cha);  
            }  ,

            getCurrentTime() {
                //获取当前时间并打印
                var _this = this;
            　　let yy = new Date().getFullYear();
            　　let mm = new Date().getMonth()+1;
            　　let dd = new Date().getDate();
            　　let hh = new Date().getHours();
            　　let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
            　　let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
            　　_this.gettime = yy+'年'+mm+'月'+dd+'日'+hh+':'+mf+':'+ss;
            　　return(_this.gettime)  
            },
        computedDate(val) {
                if (val) {
                    return moment(val).format("YYYY-MM-DD");
                }
                return "";
            },

        //获取当前时间是本月第几周
        getMonthWeek(theDate){
            let currentDay = new Date(theDate);
            // 获取该日期所在周的周六，如2019.5月的周六有4号、11号、18号、25号、31号
            let theSaturday = currentDay.getDate() + (6 - currentDay.getDay()); 
            return Math.ceil(theSaturday / 7);
        },

         //获得某月的最后一天 
          getLastDay(year,month) {        
            var new_year = year;    //取当前的年份         
            var new_month = month++;//取下一个月的第一天，方便计算（最后一天不固定）         
            if(month>12) {        
             new_month -=12;        //月份减         
             new_year++;            //年份增         
            }        
            var new_date = new Date(new_year,new_month,1);                //取当年当月中的第一天         
            return (new Date(new_date.getTime()-1000*60*60*24)).getDate();//获取当月最后一天日期         
       },

       //根据季度换算日期
        getQuarterDay(value){
            let q=value.substring(4,6)
            let year=value.substring(0,4)

           if(q=='Q1'){
               return year+'-01-01——'+year+'-03-31'
           }else if(q=='Q2'){
            return year+'-04-01——'+year+'-06-30'
           }else if(q=='Q3'){
            return year+'-07-01——'+year+'-09-30'
           }else if(q=='Q4'){
            return year+'-08-01——'+year+'-12-31'
           }
        },
        //获取当前时间
        getTime() {
            var myDate = new Date();
            var myYear = myDate.getFullYear(); //获取完整的年份(4位,1970-????)
            var myMonth = myDate.getMonth() + 1; //获取当前月份(0-11,0代表1月)
            var myToday = myDate.getDate(); //获取当前日(1-31)
            var myDay = myDate.getDay(); //获取当前星期X(0-6,0代表星期天)
            var myHour = myDate.getHours(); //获取当前小时数(0-23)
            var myMinute = myDate.getMinutes(); //获取当前分钟数(0-59)
            var mySecond = myDate.getSeconds(); //获取当前秒数(0-59)
            var week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
            var nowTime;
        
           // nowTime = myYear + '年' + fillZero(myMonth) + '月' + fillZero(myToday) + '日' + '  ' + fillZero(myHour) + ':' +
              //  fillZero(myMinute) + ':' + fillZero(mySecond) + '  ' + week[myDay] + '  ';
                nowTime = myYear + '-' + this.fillZero(myMonth) + '-' + this.fillZero(myToday);
            return( myYear + '-' + this.fillZero(myMonth) + '-' + this.fillZero(myToday))  
        },
        
         fillZero(str) {
            var realNum;
            if (str < 10) {
                realNum = '0' + str;
            } else {
                realNum = str;
            }
            return realNum;
        },
        /*
        * 获取当前时间前几日数据，length为天数
        * myGetDay(0) -- 今日
        * 格式 2021-08-19
        * */
         myGetDay(length) {
                var time = (new Date).getTime() - 24 * 60 * 60 * 1000 * length;
                var yesday = new Date(time); // 获取的是前几天日期
                yesday = yesday.getFullYear() + "-" + (yesday.getMonth()>= 9 ? (yesday.getMonth() + 1) : "0" + (yesday.getMonth() + 1)) + "-" +(yesday.getDate()> 9 ? (yesday.getDate()) : "0" + (yesday.getDate())); //字符串拼接转格式：例如2018-08-19
                return yesday
            },
        /**
         * 
         *获取AddDayCount天后的日期
         */
         GetDateStr(AddDayCount) {
                var dd = new Date();
                dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
                var y = dd.getFullYear();
                var m = dd.getMonth()+1;//获取当前月份的日期
                var d = dd.getDate();
                return y+"-"+m+"-"+d;
                }
        
    
 
}


// WEBPACK FOOTER //
// ./src/utils/date.js